import type { ReportFilters } from '../types/api';

export const qk = {
  me: ['me'] as const,
  bootstrap: ['bootstrap'] as const,
  entries: ['entries'] as const,
  activity: ['activity'] as const,
  dashboard: (from: number, to: number, onlyMe: boolean) => ['dashboard', from, to, onlyMe] as const,
  reportSummary: (f: ReportFilters, groupBy: string) => ['report', 'summary', f, groupBy] as const,
  reportDetailed: (f: ReportFilters) => ['report', 'detailed', f] as const,
  timeoff: (scope: string) => ['timeoff', scope] as const,
  teams: ['teams'] as const,
  projects: ['projects'] as const,
  projectTasks: (id: string) => ['projects', id, 'tasks'] as const,
  users: ['users'] as const,
  invites: ['invites'] as const,
};
